import { MatDialogConfig } from '@angular/material/dialog';

export type DialogSize = 's' | 'm' | 'l' | 'xl';

const DIALOG_SIZE_WIDTHS: Record<DialogSize, string> = {
    s: '300px',
    m: '500px',
    l: '700px',
    xl: '1200px',
};

function isDialogSize(width: string): width is DialogSize {
    return width in DIALOG_SIZE_WIDTHS;
}

export function getDialogConfig(data?: any, width?: string | DialogSize): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.restoreFocus = false;
    if (data) { dialogConfig.data = data; }
    if (width) { dialogConfig.width = isDialogSize(width) ? DIALOG_SIZE_WIDTHS[width] : width; }
    return dialogConfig;
}
